import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';

// Bootstrap components
import Col from 'react-bootstrap/Col';

// Spinning wheel
import {ReactSpinner} from 'react-spinning-wheel';
import 'react-spinning-wheel/dist/style.css';

// You can style your pagination component
// thanks to styled-components.
// Use inner class names to style the controls.
const MyPaginate = styled(ReactPaginate).attrs({
    // You can redefine classes here, if you want.
    activeClassName: 'active', // default to "selected"
  })`
    margin: 0.3rem 0rem 0.3rem 0rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    list-style-type: none;
    padding: 0rem;
    li a {
      border-radius: 7px;
      padding: 0rem 0.5rem;
      border: gray 1px solid;
      cursor: pointer;
    }
    li.previous a,
    li.next a,
    li.break a {
      border-color: transparent;
    }
    li.active a {
      background-color: #0366d6;
      border-color: transparent;
      color: white;
      min-width: 32px;
    }
    li.disabled a {
      color: grey;
    }
    li.disable,
    li.disabled a {
      cursor: default;
    }
  `;

// currentItems: the items to display
// config: the background generator config files (props)
// addAssetToCanvasFunction: function to add assets to the canvas 
function Items({ currentItems, config, addAssetToCanvasFunction }) {

  return (
    <>
    { currentItems !== null ? (
        <div className="row pl-3 pr-3 mb-2 mr-1 ml-1">
            { currentItems.map((d, index) => ( 
                <Col key={`PaginatedItem_` + index} className="col">
                    <img
                        className="mt-1"
                        alt={d.name}
                        src={d.image_local_file_thumbnail}
                        width={74}
                        draggable={d.image_local_file_thumbnail === d.image_local_file_transparent}
                        onClick={(e) => {
                            if (!d.addedToCanvas) {
                                addAssetToCanvasFunction(e, d, true, d.image_local_file_transparent);
                            }
                        }}
                        // onDragStart={(e) => {
                        //     dragUrl.current = e.target.src;
                        //     dragUrlId.current = d.index;
                        //     dragUrlHeight.current = e.target.height;
                        //     dragUrlWidth.current = e.target.width;
                        // }} 
                        title={d.name}
                    />
                    { (config.displayItemLegendConfig.assets === true) && 
                        <span className="row justify-content-center BGAssetLegend">{d.name}</span> 
                    }
                </Col>
            ))}
        </div>
    ) : (
        <Col className="d-flex flex-column align-items-center col-lg-12">
            <div className=""><ReactSpinner /><strong>Loading data...</strong></div>
        </Col>
    )}
    </>
  );
}

function PaginatedItems({ itemsPerPage, data, config, addAssetToCanvasFunction }) {

  // itemsPerPage: nb of items to display per page
  // data: the data object (as a map, not an array)
  // currentItems: items slices to be displayed on the current page 

  // Here we use item offsets
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  
  //console.log("PaginatedItems: Data: " , data);
  //console.log("PaginatedItems: Loading items from " + itemOffset + " to " + endOffset);
  //console.log("PaginatedItems: Total results:" + totalResults);

  // the data passed in this function is map and need to be an array
  const dataAsArray = data.reduce(function (rows, key, index) { 
    return (index % 9999999 === 0 ? rows.push([key]) 
        : rows[rows.length-1].push(key)) && rows;
  }, []);

  // If we get an empty array, we prevent the app to crash
  // By providing empty results 
  const totalResults = data.length;
  let currentItems = null; let pageCount = 0; let currentPage = 0;
  if (totalResults > 0) {

    if (itemOffset > 0) {
        currentPage = Math.ceil(endOffset / itemOffset);
    } else {
        currentPage = 1;
    }

    currentItems = dataAsArray[0].slice(itemOffset, endOffset);
    //console.log("PaginatedItems: Current page data: " , currentItems);
    pageCount = Math.ceil(totalResults / itemsPerPage);
  } 

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % totalResults;
    //console.log("User requested page number ${event.selected}, which is offset ${newOffset}");
    setItemOffset(newOffset);
  };

  return (
    <>

      {/* Display the results  */}
      <Items currentItems={currentItems} config={config} addAssetToCanvasFunction={addAssetToCanvasFunction} />

      {/* Display the pagination controls */}
      <MyPaginate
         breakLabel="..."
         nextLabel=">"
         onPageChange={handlePageClick}
         marginPagesDisplayed={1}
         pageRangeDisplayed={3}
         pageCount={pageCount}
         previousLabel="<"
         renderOnZeroPageCount={null}
         containerClassName={'pagination'}
         activeClassName={'active'}
      />
      <p className="carousel-caption-custom">Page {currentPage}/{pageCount} (Total results: {totalResults})</p>

    </>
  );
}

export default PaginatedItems;